
import {createContext, useState} from 'react'

const Context = createContext()

export const WarehouseContextProvider = ({children}) => {
 const [allWarehouses, setAllWarehouses] = useState([])
 return <Context.Provider value={{allWarehouses, setAllWarehouses}}>
  {children}
 </Context.Provider>
}
export default Context